module.exports = __webpack_public_path__ + "static/media/img75_R.f77bb381.jpg";